import { Typography } from "@/components";
import CollectionsTwoToneIcon from "@mui/icons-material/CollectionsTwoTone";

const EmptyGallery = () => {
	return (
		<div className="h-full w-full flex flex-col justify-center items-center gap-3">
			<div className="bg-white rounded-[3rem] p-7">
				<CollectionsTwoToneIcon className="!text-[5rem]" />
			</div>
			<Typography fontWeight={700} fontSize={16}>
				No files
			</Typography>
		</div>
	);
};

export default EmptyGallery;
